interface State {
  flowExecutionId: string;
}

const initialState: State = {
  flowExecutionId: '',
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_FLOW_EXECUTION_ID':
      return {
        ...state,
        flowExecutionId: payload,
      };

    default:
      return state;
  }
}
